/* eslint-disable react/prop-types */
import classes from "./composed-view-ten.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import classNames from "classnames";
function ComposedViewTen({
  title,
  content,
  subContentTitle,
  subContent,
  subContent2Title,
  subContent2,
  className,
  Table,
}) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      <Label
        weight="bold"
        tag="h2"
        color="secondary"
        align="start"
        className={classes.title}
      >
        {title}
      </Label>

      <Label
        size="md"
        color="secondary"
        align="start"
        className={classes.content}
      >
        {content}
      </Label>

      {Table}

      {subContentTitle && (
        <Label
          tag="h6"
          align="start"
          weight="bold"
          color="secondary"
          className={classes.columnTitle}
        >
          {subContentTitle}
        </Label>
      )}
      <Label
        size="md"
        color="secondary"
        align="start"
        className={classes.content}
      >
        {subContent}
      </Label>
      {subContent2Title && (
        <Label
          tag="h6"
          align="start"
          weight="bold"
          color="secondary"
          className={classes.columnTitle}
        >
          {subContent2Title}
        </Label>
      )}
      {subContent2 && (
        <Label
          size="md"
          color="secondary"
          align="start"
          className={classes.content}
        >
          {subContent2}
        </Label>
      )}
    </Flex>
  );
}

export default ComposedViewTen;
